var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-pos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-3169.000000, -1633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-pos",
    transform: "translate(3169.000000, 1633.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 257,
    cy: 459,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sync-with-mobile_line_15",
    transform: "translate(100.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.101852,134.320473 C163.740741,114.275127 136.564815,101.8 106.481481,101.8 C47.6759259,101.8 0,149.451655 0,208.227273 C0,258.655291 35.0925926,300.893036 82.1944444,311.878182",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.5185185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.296296,81.4122364 C293.574074,64.3838727 278.314815,50.9277636 259.981481,43.4686",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.5185185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.305556,37.8881091 C235.240741,37.3143273 231.083333,37.0181818 226.851852,37.0181818 C222.555556,37.0181818 218.324074,37.3235818 214.194444,37.9251273",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.5185185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.740741,397.945455 L240.740741,490.490909 C240.740741,500.717182 249.027778,509 259.259259,509 L481.481481,509 C491.712963,509 500,500.717182 500,490.490909 L500,175.836364 C500,165.610091 491.712963,157.327273 481.481481,157.327273 L259.259259,157.327273 C249.027778,157.327273 240.740741,165.610091 240.740741,175.836364 L240.740741,268.381818",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.5185185
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "379.62963 462.727273 361.111111 462.727273 361.111111 481.236364 379.62963 481.236364"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(77.805556, 0.000000)",
    stroke: "#000000",
    strokeWidth: 18.5185185
  }, /*#__PURE__*/React.createElement("line", {
    x1: 162.935185,
    y1: 434.963636,
    x2: 422.194444,
    y2: 434.963636,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.935185,
    y1: 194.345455,
    x2: 422.194444,
    y2: 194.345455,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.824074,296.145455 L135.157407,296.145455 C119.814815,296.145455 107.37963,283.7166 107.37963,268.381818 L107.37963,203.6",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "268.509259 329.443309 301.824074 296.145455 268.490741 262.829091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3055556,175.836364 L33.3055556,342.418182 C33.3055556,357.752964 45.7407407,370.181818 61.0833333,370.181818 L237.009259,370.181818",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 209.124964 33.3055556 175.836364 66.6574074 209.171236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.009259,157.327273 C337.203704,134.755436 309.666667,120.309091 278.675926,120.309091 L273.925926,120.309091 C271.518519,53.4542545 217.259259,0 150.62963,0 C90.2777778,0 40.0462963,43.8572909 29.3333333,101.8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.37963,
    y1: 166.581818,
    x2: 107.37963,
    y2: 185.090909,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.527778,
    y1: 370.181818,
    x2: 274.046296,
    y2: 370.181818,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.564815,
    y1: 370.181818,
    x2: 311.083333,
    y2: 370.181818,
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ac8376c37bea2c468b9eb670597b66db.svg";
export { ForwardRef as ReactComponent };